const ALLOWED_KEYS = [
  '1',
  '2',
  '3',
  '4',
  '5',
  '6',
  '7',
  '8',
  '9',
  '0',
  '-',
  ',',
  '.',
  'Backspace',
  'Meta',
  'ArrowLeft',
  'ArrowRight',
  'ArrowDown',
  'ArrowUp',
];

export default ALLOWED_KEYS;
